import React from 'react'
import upperCase from 'lodash/upperCase'
import moment from 'moment'
import {AutoSizer, Table, Column, InfiniteLoader} from 'react-virtualized'

function TableUnlistedItem(props) {
  const _noRowsRenderer = () => {
    return (
      <div className="text_center audit-table__cell--none audit-table__cell--gray audit-table__cell--expand">
        <span className="font_20">No Records Found</span>
      </div>
    )
  }

  return (
    <div className="main-container">
      <h1 className="tableTitleText">
        Infinite scrolling autosize table for unlisted item for specific audit with details
      </h1>
      <InfiniteLoader>
        {({onRowsRendered, registerChild}) => (
          <AutoSizer className="full_auto_width">
            {({width}) => (
              <Table
                ref={registerChild}
                onRowsRendered={onRowsRendered}
                className="audit-table"
                rowClassName="audit-table__row audit-table__row--35 audit-table__row--no-border-top"
                headerHeight={33}
                height={545}
                width={width}
                rowHeight={33}
                rowCount={props.data.length}
                rowGetter={({index}) => props.data[index]}
                rowStyle={{overflow: 'visible'}}
                noRowsRenderer={_noRowsRenderer}
              >
                <Column
                  className="item-table__header"
                  cellRenderer={c => (
                    <div className="overflow-content">{c.rowData.scanned_code}</div>
                  )}
                  label={upperCase('Unique Identifier')}
                  dataKey="scanned_code"
                  width={width * 0.15}
                />
                <Column
                  className="item-table__header"
                  cellRenderer={c => <div className="overflow-content">{c.rowData.comment}</div>}
                  label={upperCase('Notes')}
                  dataKey="comment"
                  width={width * 0.4}
                />
                <Column
                  className="item-table__header"
                  cellRenderer={c => (c.rowData.entity_exists ? 'Yes' : 'No')}
                  label={upperCase('Item in Database')}
                  dataKey="entity_exists"
                  width={width * 0.15}
                />
                <Column
                  className="item-table__header"
                  cellRenderer={c => moment(c.rowData.scanned_date).format(`${props.date_format}`)}
                  label={upperCase('Date Scanned')}
                  dataKey="id"
                  width={width * 0.15}
                />
                <Column
                  disableSort={true}
                  className="audit-table__header audit-table__header--right audit-item-tab__cell--right"
                  label={upperCase('Scanned By')}
                  dataKey="user_name"
                  width={width * 0.15}
                />
              </Table>
            )}
          </AutoSizer>
        )}
      </InfiniteLoader>
    </div>
  )
}

export default TableUnlistedItem
